import { render, staticRenderFns } from "./ModalProduto.vue?vue&type=template&id=340c63ee&scoped=true"
import script from "./ModalProduto.vue?vue&type=script&lang=js"
export * from "./ModalProduto.vue?vue&type=script&lang=js"
import style0 from "./ModalProduto.vue?vue&type=style&index=0&id=340c63ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340c63ee",
  null
  
)

export default component.exports